
import Vue from 'vue';
import { api, DataQualityPeriod, DataQualityReport, DuplicateCandidate } from '@/services/api';
import { visualizeAmount } from '@/services/visualizer';
import { formatDate } from '@/services/date';

export default Vue.extend({
    data() {
        return {
            report: null as DataQualityReport | null,
            selectedLabel: "Last year"
        }
    },
    async mounted() {
        await this.refresh();
    },
    methods: {
        async refresh() {
            this.report = await api.getDataQualityReport();
            if (this.report && !this.selectedPeriod) {
                this.selectedLabel = this.report.periods[0]?.label || "";
            }
        },
        money(amount: number): string {
            return visualizeAmount(amount);
        },
        percent(value: number): string {
            return `${(value * 100).toFixed(1)}%`;
        },
        formatDate(date: string): string {
            return formatDate(new Date(date));
        },
        duplicateKey(candidate: DuplicateCandidate): string {
            return `${candidate.date}:${candidate.amount}:${candidate.description}`;
        }
    },
    computed: {
        selectedPeriod(): DataQualityPeriod | null {
            if (!this.report) {
                return null;
            }
            return this.report.periods.find(period => period.label === this.selectedLabel) || this.report.periods[0] || null;
        }
    }
})
